import * as Selectors  from './selectors';
import { useMemo }     from 'react';
import { useSelector } from 'react-redux';


// Conversations hooks

// Selectors

export function useConversations(businessID) {
  const conversations = useSelector(state => Selectors.getConversations(state, businessID));
  const sorted        = useMemo(() => conversations.sort(byMostRecentlyActive), [ conversations ]);
  return sorted;
}

function byMostRecentlyActive(a, b) {
  if (a.lastActive < b.lastActive)
    return 1;
  else if (a.lastActive > b.lastActive)
    return -1;
  else
    return 0;
}


export function useConversationsStatuses(businessID) {
  return useSelector(state => Selectors.getConversationsStatuses(state, businessID));
}
